type ApiError = { response?: { data?: unknown } };

/**
 * First message of a DRF error response: `non_field_errors` or, failing that,
 * the first field error. Falls back to the given message when the response
 * carries none (network errors, HTML error pages...).
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as ApiError)?.response?.data;
  if (!data || typeof data !== 'object') {
    return fallback;
  }
  const errors = data as Record<string, unknown>;
  const message = [errors.non_field_errors, ...Object.values(errors)]
    .flat()
    .find((value) => typeof value === 'string' && value);
  return (message as string) || fallback;
}
